// @flow
import React from 'react';

type SwitchProps = {
    checked: boolean,
    onToggle: (state: boolean) => void,
    renderLeftLabel: () => any,
    renderRightLabel: () => any
}

type SwitchState = {
    focused: boolean,
    checked: boolean
}

export default class Switch extends React.Component<SwitchProps, SwitchState> {

    constructor (props: SwitchProps){
        super(props);
        this.state = {checked: this.props.checked };
    }

    componentWillReceiveProps(nextProps: SwitchProps) {
        if(this.state.checked !== nextProps.checked)  this.setState({ checked: nextProps.checked });
    }

    onKeyUp = (event: KeyboardEvent): void => {
        if (!this.state.focused) return;
        if(event.key === 'Enter') this.onToggle();
    };

    onToggle= (): void => {
       this.props.onToggle(!this.state.checked);
    };

    render () {
        return (
            <div className="switch-wrapper small">
                <input key="switch--input--hidden" id="switch--input_solo" className="switch--input" type="checkbox" onChange={ () => {} } checked={this.state.checked}/>
                <label tabIndex="0" onKeyUp={ this.onKeyUp } onFocus={ () => this.setState({focused: true}) } onBlur={ () => this.setState({focused: false}) } key="switch--toggle" htmlFor="switch--input_solo" className="switch" onClick={this.onToggle}>
                    <div className="switch--label-container">
                        <span className="switch--label">{ this.props.renderLeftLabel() }</span>
                        <span className="switch--label">{ this.props.renderRightLabel() }</span>
                    </div>
                    <span className="switch--toggle"></span>
                </label>
            </div>
        );
    }
}